import React, { useState, useEffect, ReactNode, useCallback } from 'react'

import { Text, csx } from '@vtex/admin-ui'
import {
  BottomSliderModal,
  BottomSliderModalCloseButton,
  BottomSliderModalContent,
  BottomSliderModalHeader,
} from '@/checkout-instore-legacy/components/Commons/BottomSliderModal'
import RightSideModal from '@/checkout-instore-legacy/components/Commons/RightSideModal'

import {
  withMediaQuery,
  WithMediaQueryProps,
  WithMediaQueryState,
} from '@/checkout-instore-legacy/utils/mediaQuery'

interface BaseModalProps {
  title: string
  isOpen?: boolean
  onClose?: () => void
  children?: ReactNode
}

type Props = BaseModalProps & WithMediaQueryState & WithMediaQueryProps

const BaseModal = (props: Props) => {
  const { title, isOpen, onClose, children, mediaQuery, ...rest } = props

  const [currentIsOpen, setCurrentIsOpen] = useState(!!isOpen)

  useEffect(() => {
    setCurrentIsOpen(!!isOpen)
  }, [isOpen])

  const isMobile = mediaQuery({
    phone: true,
    tablet: false,
    desktop: false,
  })

  const handleClose = useCallback(() => {
    onClose?.()
    setCurrentIsOpen(false)
  }, [onClose])

  const setIsOpen = useCallback(
    (result: boolean) => {
      if (!result) {
        handleClose()
      }
    },
    [handleClose]
  )

  return (
    <div {...rest}>
      <div className={csx({ marginTop: '$space-6' })}>
        {isMobile ? (
          <BottomSliderModal isOpen={currentIsOpen} onClose={handleClose}>
            <BottomSliderModalHeader>
              <Text variant="title1">{title}</Text>
              <BottomSliderModalCloseButton />
            </BottomSliderModalHeader>
            <BottomSliderModalContent>{children}</BottomSliderModalContent>
          </BottomSliderModal>
        ) : (
          <RightSideModal
            isOpen={currentIsOpen}
            title={title}
            setIsOpen={setIsOpen}
          >
            {children}
          </RightSideModal>
        )}
      </div>
    </div>
  )
}

export default withMediaQuery(BaseModal) as React.ComponentType<BaseModalProps>
